import { useLayoutEffect, useRef, useState } from "react";

const useContainerSize = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const element = containerRef.current;
    if (!element) {
      return;
    }

    const measure = () => {
      setWidth(element.offsetWidth);
      setHeight(element.offsetHeight);
    };

    measure();

    // A window listener would miss layout-driven changes - the navigation
    // collapsing, a panel opening - so observe the element itself.
    const observer = new ResizeObserver(measure);
    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return {
    containerRef,
    width,
    height,
  };
};

export default useContainerSize;
